import React from 'react';

const ColumnTooltip = ({ text }) => (
  <div className='tooltip absolute w-2.8/20 md:w-2/20 h-5 max-w-180'>
    <span className='bg-black text-white tooltip-text -mt-8'>{text}</span>
  </div>
);

export default ColumnTooltip;
